import type { EventProperties, Options } from '@segment/analytics-next';

export const localStorageSegmentDebugEnabledKey = 'segmentDebugEnabled';

export function hasDebugEnabled(): boolean {
  const storedValue = localStorage.getItem(localStorageSegmentDebugEnabledKey);

  if (storedValue === null) {
    return false;
  }

  return storedValue === 'true';
}

export function toggleSegmentDebug(): void {
  const isEnabled = hasDebugEnabled();

  localStorage.setItem(localStorageSegmentDebugEnabledKey, isEnabled ? 'false' : 'true');
}

export function debugSegmentEvent(
  eventName: string,
  properties?: EventProperties,
  options?: Options
): void {
  if (hasDebugEnabled() === true) {
    // oxlint-disable-next-line no-console
    console.info(
      `%cSegment Event%c ${eventName} %o %o`,
      'color: #5a2; font-weight: 700; border: 1px solid #5a2; padding: 2px 5px; border-radius: 5px;',
      'color: #c842b2; font-weight: 700;',
      properties,
      options
    );
  }
}

export function debugSegmentInitialization(message: string): void {
  if (hasDebugEnabled() === true) {
    // oxlint-disable-next-line no-console
    console.info(`%cSegment Init%c ${message}`,
      'color: rgb(200, 95, 66); font-weight: 700; border: 1px solid rgb(200, 95, 66);' +
      'padding: 2px 5px; border-radius: 5px;',
      'color:rgb(200, 95, 66); font-weight: 700;');
  }
}
